module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-earmark-code-2381e9ba.svg";